import {
  useState,
  type Dispatch,
  type SetStateAction,
} from 'react';
import type {
  CmarkdowntablePopoverEntry,
  CmarkdowntablePopoverPosition,
} from './Cmarkdowntable.types';

export interface CmarkdowntablePopoverStateController {
  activeRowIndex: number | null;
  setActiveRowIndex: Dispatch<SetStateAction<number | null>>;
  hoverRowIndex: number | null;
  setHoverRowIndex: Dispatch<SetStateAction<number | null>>;
  popoverEntries: CmarkdowntablePopoverEntry[] | null;
  setPopoverEntries: Dispatch<SetStateAction<CmarkdowntablePopoverEntry[] | null>>;
  popoverIdValue: string;
  setPopoverIdValue: Dispatch<SetStateAction<string>>;
  popoverPosition: CmarkdowntablePopoverPosition | null;
  setPopoverPosition: Dispatch<SetStateAction<CmarkdowntablePopoverPosition | null>>;
}

export function useCmarkdowntablePopoverState(): CmarkdowntablePopoverStateController {
  const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);
  const [hoverRowIndex, setHoverRowIndex] = useState<number | null>(null);
  const [popoverEntries, setPopoverEntries] = useState<CmarkdowntablePopoverEntry[] | null>(null);
  const [popoverIdValue, setPopoverIdValue] = useState<string>('');
  const [popoverPosition, setPopoverPosition] = useState<CmarkdowntablePopoverPosition | null>(null);

  return {
    activeRowIndex,
    setActiveRowIndex,
    hoverRowIndex,
    setHoverRowIndex,
    popoverEntries,
    setPopoverEntries,
    popoverIdValue,
    setPopoverIdValue,
    popoverPosition,
    setPopoverPosition,
  };
}
